<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Fusion Evaluation</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- Card -->
        <el-card>

            <el-row :gutter="25">
                <el-col :span="10">
                    <!-- Search method -->
                    <el-input placeholder="Enter method name">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>

                <el-col :span="4">
                    <el-button type="primary" @click="addDialogVisible = true">Add Method</el-button>
                </el-col>
            </el-row>

            <!-- Method Table -->
            <el-table :data="methodList" border stripe>
                <el-table-column type="index"></el-table-column>
                <el-table-column label="Method Name" prop="Name"></el-table-column>
                <el-table-column label="Paper" prop="SrcPaper" v-if="isAdmin"></el-table-column>
                <el-table-column label="Venue" prop="JournalConfer" v-if="isAdmin"></el-table-column>
                <el-table-column label="Channels" prop="NumChannel" v-if="isAdmin"></el-table-column>
                <el-table-column label="Year" prop="Year" v-if="isAdmin"></el-table-column>
                <el-table-column label="Actions">
                    <template slot-scope="scope">

                        <!-- Create fusion dataset -->
                        <el-tooltip effect="dark" content="Create dataset" placement="top-start" :enterable="false">
                            <el-button type="warning" icon="el-icon-circle-plus" size="mini"
                                @click="createMethod(scope.row.MethodID, scope.row.Name)">
                            </el-button>
                        </el-tooltip>

                        <!-- View datasets -->
                        <el-tooltip effect="dark" content="View datasets" placement="top-start" :enterable="false">
                            <el-button type="success" icon="el-icon-view" size="mini"
                                @click="viewMethod(scope.row.MethodID)">
                            </el-button>
                        </el-tooltip>

                        <!-- Delete method -->
                        <el-tooltip effect="dark" content="Delete method" placement="top-start" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                @click="deleteMethod(scope.row.MethodID)">
                            </el-button>
                        </el-tooltip>

                    </template>
                </el-table-column>
            </el-table>

            <!-- Create dataset dialog -->
            <el-dialog title="Create Fusion Dataset" :visible.sync="addFusionDBDialogVisible" width="50%" @close="addDialogClosed">
                <el-form :model="fusionDBForm" label-width="120px" class="fusion-form">

                    <el-form-item label="Method Name" required>
                        <el-input v-model="fusionDBForm.Name" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="Dataset">
                        <el-select v-model="fusionDBForm.DatasetID" placeholder="Select dataset" style="width: 100%">
                            <template slot="prefix">
                                <i class="iconfont icon-shujuku"></i>
                            </template>
                            <el-option v-for="(dataset, index) in datasetlist"
                                :key="index"
                                :label="dataset.Name"
                                :value="dataset.DatasetID">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Upload File">
                    <el-upload
                      class="upload-demo"
                      drag
                      action=''
                      :on-change="handleChange"
                      :before-upload="beforeUpload"
                      :file-list="fileList"
                      accept=".zip"
                      :limit="1"
                      :auto-upload="false"
                    >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                              Drag a <b>.zip</b> file (≤ 50MB) here, or <em>click to upload</em>
                            </div>
                        </el-upload>
                        <div v-if="fileError" class="error" style="color: red; margin-top: 10px;">
                            {{ fileError }}
                        </div>
                    </el-form-item>

                  <el-form-item>
                    <div style="margin-top: -30px; margin-bottom: 20px;">
                        <el-button size="mini" type="info" plain @click="showConvertCodeDialog = true">
                             Need smaller files? Click here to show JPG conversion code.
                        </el-button>
                    </div>
                  </el-form-item>


                    <el-form-item>
                        <el-button type="primary" @click="submit" style="width: 100%;">
                            Create Dataset
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>


            <el-dialog
                title="Convert Images to JPG"
                :visible.sync="showConvertCodeDialog"
                width="60%">
                <div style="margin-bottom: 10px; color: #666; line-height: 1.6;">
                    If your uploaded images are too large, you can convert them to JPG format first to reduce file size.
                </div>

                <pre class="code-block">{{ jpgConvertCode }}</pre>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="showConvertCodeDialog = false">Close</el-button>
                </span>
            </el-dialog>

            <!-- Add method dialog -->
            <el-dialog title="Add Method" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
                <el-form :model="form">

                    <el-form-item label="Method Name">
                        <el-input v-model="form.Name"></el-input>
                    </el-form-item>

                    <el-form-item label="Paper Title" v-if="isAdmin">
                        <el-input v-model="form.SrcPaper"></el-input>
                    </el-form-item>

                    <el-form-item label="Venue" v-if="isAdmin">
                        <el-input v-model="form.JournalConfer"></el-input>
                    </el-form-item>

                    <el-form-item label="Channels" v-if="isAdmin">
                        <el-input type="number" v-model.number="form.NumChannel"></el-input>
                    </el-form-item>

                    <el-form-item label="Year" v-if="isAdmin">
                        <el-input type="number" v-model.number="form.Year"></el-input>
                    </el-form-item>

                    <el-form-item label="Description">
                        <el-input type="textarea" v-model="form.Description"></el-input>
                    </el-form-item>

                    <el-form-item v-if="!isAdmin">
                        <div style="color:#6b7280;font-size:12px;line-height:1.6;">
                            Submitted methods are marked as unpublished by default.<br>
                            Each user can keep at most 3 methods. When a 4th method is created, the earliest one will be deleted automatically.
                        </div>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="submitMethod">
                            Create Method
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>

            <!-- View dataset dialog -->
            <el-dialog title="Existing Datasets" :visible.sync="viewFusionDBDialogVisible" width="50%" @close="addDialogClosed">
                <el-table :data="fusiondatasetlist" border stripe>

                    <el-table-column type="index"></el-table-column>
                    <el-table-column label="Dataset Name" prop="Name"></el-table-column>
                    <el-table-column label="Image Count" prop="NumImgs"></el-table-column>
                    <el-table-column label="Description" prop="Description"></el-table-column>
                    <el-table-column label="Source" prop="SrcPaper"></el-table-column>

                    <el-table-column fixed="right" label="Actions">
                        <template slot-scope="scope">

                            <el-tooltip effect="dark" content="Evaluate dataset" placement="top-start" :enterable="false">
                                <el-button type="warning" icon="el-icon-cpu" size="mini"
                                    @click="evaluateFusionDataset(scope.row.DatasetID)">
                                </el-button>
                            </el-tooltip>

                            <el-tooltip effect="dark" content="Delete dataset" placement="top-start" :enterable="false">
                                <el-button type="danger" icon="el-icon-delete" size="mini"
                                    @click="deleteFusionDataset(scope.row.DatasetID)">
                                </el-button>
                            </el-tooltip>

                        </template>
                    </el-table-column>

                </el-table>
            </el-dialog>

            <!-- Evaluation dialog -->
            <el-dialog title="EvaNet Evaluation" :visible.sync="dialogVisible" @close="handleClose" width="400px">
                <div style="margin-bottom: 12px; color: #666;">
                    All EvaNet metrics will be evaluated by default and cannot be modified.
                </div>

                <el-checkbox-group v-model="selectMetircList">
                    <el-checkbox
                        v-for="(option, index) in metricList"
                        :key="index"
                        :label="option.MetricID"
                        disabled>
                        {{ option.Name }}
                    </el-checkbox>
                </el-checkbox-group>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="confirmSelection">Confirm</el-button>
                </span>
            </el-dialog>

        </el-card>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import JSZip from 'jszip';

export default {
    name: "MethodManagement",
    data() {
        return {
            isAdmin: false,
            fusiondatasetlist: [],// 某一方法融合数据集列表

            datasetlist: [],// 数据集列表

            methodList: [], // 方法列表
            addDialogVisible: false, // 添加对话框显示状态


            fileList: [],   //webpack上传文件列表
            fileError: '',      //webpack上传文件错误信息


            metricList: [], // 指标列表


            selectMetircList: [], // 选择的指标列表


            evaluatedmetirclist: [], // 已评测的指标列表

            uploadProgress: 0,
            uploadSpeed: '',
            uploadRemainingTime: '',
            uploadStartTime: 0,

            addFusionDBDialogVisible: false, // 添加对话框显示状态

            viewFusionDBDialogVisible: false, // 查看方法融合数据集对话框显示状态

            //创建方法格式
            form: {
                Name: '',
                SrcPaper: '',
                JournalConfer: '',
                NumChannel: 3,
                Year: new Date().getFullYear(),
                Description: ''
            },

            //创建融合数据集格式
            fusionDBForm: {
                MethodID: '',
                Name: '',
                DatasetID: '',
            },
            //创建删除融合数据集格式
            deletefusionDBForm: {
                MethodID: '',
                DatasetID: '',
            },


            //创建测评融合数据集格式
            evaluatefusionDBForm: {
                MethodID: '',
                DatasetID: '',
            },

            dialogVisible: false, // 控制对话框是否显示

            showConvertCodeDialog: false,

            jpgConvertCode: `from PIL import Image
import os
target_folder = "fusion"
output_folder = "fusion_jpg"

os.makedirs(output_folder, exist_ok=True)

for f in os.listdir(target_folder):
    p = os.path.join(target_folder, f)
    if os.path.isfile(p):
        try:
            Image.open(p).convert('RGB').save(
                os.path.join(output_folder, os.path.splitext(f)[0] + '.jpg')
            )
        except:
            pass`

        };
    },
    created() {
    const userStr = window.sessionStorage.getItem("user");
    const user = JSON.parse(userStr);

    this.isAdmin = Number(user.Level) > 0;
    if (!userStr) {
        this.$message.error("Please log in first");
        this.$router.push("/login");
        return;
    }

    try {
        const user = JSON.parse(userStr);
        if (!user || !user.access_token) {
            this.$message.error("Invalid session. Please log in again");
            this.$router.push("/login");
            return;
        }
    } catch (e) {
        this.$message.error("Session error. Please log in again");
        this.$router.push("/login");
        return;
    }

    this.getMethodList();
    this.getDatasetList();
    this.getMetircList();
},
    methods: {
  formatBytes(bytes) {
    if (!bytes || bytes <= 0) return '0 B/s';
    const units = ['B/s', 'KB/s', 'MB/s', 'GB/s'];
    let i = 0;
    let value = bytes;
    while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i++;
    }
    return value.toFixed(value >= 10 ? 1 : 2) + ' ' + units[i];
},

formatSeconds(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '--';
    const s = Math.floor(seconds);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;

    if (h > 0) return `${h}h ${m}m ${sec}s`;
    if (m > 0) return `${m}m ${sec}s`;
    return `${sec}s`;
},
getAuthHeaders(isFormData = false) {
    const userStr = window.sessionStorage.getItem("user");
    if (!userStr) return {};

    try {
        const user = JSON.parse(userStr);
        if (!user || !user.access_token) return {};

        const headers = {
            Authorization: "Bearer " + user.access_token
        };

        if (!isFormData) {
            headers["Content-Type"] = "application/json";
        }

        return headers;
    } catch (e) {
        console.error("解析 user 失败:", e);
        return {};
    }
},

handleRequestError(error, defaultMsg) {
    console.error(error);
    const msg =
      (error.response &&
       error.response.data &&
       (error.response.data.msg || error.response.data.error)) ||
      defaultMsg;

    this.$message.error(msg);

    if (error.response && error.response.status === 401) {
        window.sessionStorage.removeItem("user");
        this.$router.push("/login");
    }
},
        // 获取方法列表
        async getMethodList() {
            try {
                const response = await this.$http.get("/method/show_by_user", {
                    headers: this.getAuthHeaders(),
                });
                this.methodList = response.data;
                console.log(this.methodList);
            } catch (error) {
                this.handleRequestError(error, "Failed to fetch method list");
            }
        },

        // 创建方法
        async submitMethod() {
            try {
                if (!this.isAdmin && this.methodList.length >= 3) {
                    const oldestMethod = [...this.methodList].sort(
                        (a, b) => Number(a.MethodID) - Number(b.MethodID)
                    )[0];

                    const confirmResult = await this.$confirm(
                        `You can keep at most 3 methods. If you create a new one, the earliest method${oldestMethod ? ` "${oldestMethod.Name}"` : ''} will be deleted automatically. Continue?`,
                        'Warning',
                        {
                            confirmButtonText: 'Confirm',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                        }
                    ).catch(() => false);

                    if (!confirmResult) {
                        return this.$message.info("Creation cancelled");
                    }
                }

                const response = await this.$http.post("/method/create", this.form, {
                    headers: this.getAuthHeaders(),
                });

                this.$message.success(response.data.msg);
                await this.getMethodList();
            } catch (error) {
                this.handleRequestError(error, "Failed to create method");
            } finally {
                this.addDialogVisible = false;
                this.resetForm();
            }
        },

        async deleteMethod(MethodID) {
            const confirmResult = await this.$confirm('This action will permanently delete the method. Continue?', 'Warning', {
confirmButtonText: 'Confirm',
cancelButtonText: 'Cancel',
                type: 'warning',
            }).catch(() => false);

            if (!confirmResult) {
                return this.$message.info("Deletion cancelled");
            }

            try {
                const response = await this.$http.post("/method/delete_method", { MethodID }, {
                    headers: this.getAuthHeaders(),
                });
                this.$message.success(response.data.msg);
                this.getMethodList();
            } catch (error) {
                this.handleRequestError(error, "Failed to delete method");
            }
        },



        //删除融合方法数据集
        async deleteFusionDataset(DatasetID) {
            this.deletefusionDBForm.DatasetID = DatasetID;
            console.log(this.deletefusionDBForm);

            const confirmResult = await this.$confirm('This action will permanently delete the fusion dataset. Continue?', 'Warning', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning',
            }).catch(() => false);

            if (!confirmResult) {
                return this.$message.info("Deletion cancelled");
            }

            try {
                const response = await this.$http.post("/method/delete_dataset", this.deletefusionDBForm, {
                    headers: this.getAuthHeaders(),
                });
                this.$message.success(response.data.msg);
                this.viewMethod(this.deletefusionDBForm.MethodID);
            } catch (error) {
                this.handleRequestError(error, "Failed to delete dataset");
            }
        },

        //方法表单重置
        resetForm() {
            this.form = {
                Name: '',
                SrcPaper: '',
                JournalConfer: '',
                NumChannel: 3,
                Year: new Date().getFullYear(),
                Description: ''
            };
        },

        //关闭创建方法对话框
        addDialogClosed() {
            this.resetForm();
        },

        // 数据集列表获取
        async getDatasetList() {
            try {
                const response = await this.$http.get("/dataset/getall", {
                    headers: this.getAuthHeaders()
                });

                console.log(JSON.stringify(response.data, null, 2));
                this.datasetlist = response.data;
                console.log(JSON.parse(JSON.stringify(this.datasetlist)));
            } catch (error) {
                this.handleRequestError(error, "Failed to fetch dataset list");
            }
        },

        // 数据集列表获取
      createMethod(methodID, methodName) {
          this.addFusionDBDialogVisible = true;

          this.fusionDBForm.MethodID = methodID;
          this.fusionDBForm.Name = methodName;

          // ⭐ 默认选中第一个数据集
          //if (this.datasetlist && this.datasetlist.length > 1) {
            //  this.fusionDBForm.DatasetID = this.datasetlist[1].DatasetID;
          //}
      },


      async beforeUpload(file) {
        this.fileError = '';

        // ⭐ ① 文件类型检查
        if (!file.name.endsWith('.zip')) {
          this.fileError = 'Only .zip files are allowed';
          return false;
        }

        // ⭐ ② 文件大小限制（50MB）
        const maxSize = 50 * 1024 * 1024;
        if (file.size > maxSize) {
          this.fileError = 'File size must not exceed 50MB';
          return false;
        }

        const zip = new JSZip();
        try {
          const contents = await zip.loadAsync(file);
          const fileNames = Object.keys(contents.files);

          const hasDeepDirs = fileNames.some(name => {
            const cleanName = name.replace(/\/$/, '');
            const depth = cleanName.split('/').length - 1;
            return depth >= 2;   // ❗ 两层及以上不允许
          });

          if (hasDeepDirs) {
            this.fileError = 'Only one directory level is allowed';
            return false;
          }

          return true;

        } catch (error) {
          this.fileError = 'Failed to read ZIP file';
          console.error(error);
          return false;
        }
      },

      handleChange(file) {
          this.fileError = '';

          const rawFile = file.raw || file;

          // 1. 类型检查
          if (!rawFile.name.toLowerCase().endsWith('.zip')) {
              this.fileError = 'Only .zip files are allowed';
              this.$message.error(this.fileError);
              this.fileList = [];
              return;
          }

          // 2. 大小检查
          const maxSize = 50 * 1024 * 1024;
          if (rawFile.size > maxSize) {
              this.fileError = 'File size must not exceed 50MB';
              this.$message.error(this.fileError);
              this.fileList = [];
              return;
          }

          // 合法才加入列表
          this.fileList = [file];
      },
async submit() {
    if (this.fileList.length === 0) {
        this.fileError = 'No file uploaded';
        return;
    }

    this.uploadProgress = 0;
    this.uploadSpeed = 'Calculating...';
    this.uploadRemainingTime = '--';
    this.uploadStartTime = Date.now();

    const loading = this.$loading({
        lock: true,
       text: 'Uploading... 0%',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });

    const formData = new FormData();
    formData.append('MethodID', this.fusionDBForm.MethodID);
    formData.append('DatasetID', this.fusionDBForm.DatasetID);
    formData.append('data', this.fileList[0].raw);

    try {
        const response = await this.$http.post("/method/upload", formData, {
            headers: this.getAuthHeaders(true),
            onUploadProgress: (progressEvent) => {
                if (!progressEvent.total) return;

                const loaded = progressEvent.loaded;
                const total = progressEvent.total;

                const percent = Math.round((loaded / total) * 100);
                this.uploadProgress = percent;

                const elapsedSeconds = (Date.now() - this.uploadStartTime) / 1000;
                const speed = elapsedSeconds > 0 ? loaded / elapsedSeconds : 0;
                this.uploadSpeed = this.formatBytes(speed);

                const remainingBytes = total - loaded;
                const remainingSeconds = speed > 0 ? remainingBytes / speed : Infinity;
                this.uploadRemainingTime = this.formatSeconds(remainingSeconds);

                loading.setText(
                   `Uploading... ${percent}%\nSpeed: ${this.uploadSpeed}\nRemaining: ${this.uploadRemainingTime}`
                );
            }
        });

        this.$message.success(response.data.msg);
    } catch (error) {
        this.handleRequestError(error, "Failed to create dataset");
    } finally {
        loading.close();
        this.addFusionDBDialogVisible = false;
        this.fileList = [];
        this.fusionDBForm.MethodID = '';
        this.fusionDBForm.Name = '';
        this.fusionDBForm.DatasetID = '';
        this.fileError = '';
        this.uploadProgress = 0;
        this.uploadSpeed = '';
        this.uploadRemainingTime = '';
        this.uploadStartTime = 0;
        this.getDatasetList();
    }
},


        async viewMethod(MethodID) {
            this.deletefusionDBForm.MethodID = MethodID;
            this.evaluatefusionDBForm.MethodID = MethodID;

            try {
                const response = await this.$http.get("/method/get_dataset_by_method?MethodID=" + MethodID, {
                    headers: this.getAuthHeaders(),
                });
                this.fusiondatasetlist = response.data;
                this.viewFusionDBDialogVisible = true;

                console.log(response);
            } catch (error) {
                this.handleRequestError(error, "Failed to load method details");
            }
        },


        // 获取指标列表
        async getMetircList() {
            try {
                const response = await this.$http.get("/metrics", {
                    headers: this.getAuthHeaders(),
                });

                const evanetMetricNames = [
                    "vif", "qabf", "ssim", "cc", "psnr",
                    "fmi_dct", "fmi_wave", "fmi_pixel",
                    "scd", "mi", "AG", "EI", "EN", "SD", "SF"
                ];

                this.metricList = response.data.filter(item =>
                    evanetMetricNames.includes(item.PyFile || item.Name)
                );
            } catch (error) {
                this.handleRequestError(error, "Failed to fetch metric list");
            }
        },




        async evaluateFusionDataset(DatasetID) {
            this.evaluatefusionDBForm.DatasetID = DatasetID;
            await this.getevaluatedMetircList(this.evaluatefusionDBForm);

            // 默认全选全部 EvaNet 指标
            this.selectMetircList = this.metricList.map(item => item.MetricID);

            this.dialogVisible = true;
        },

        // 获取某个融合结果已经被评估过的指标
        async getevaluatedMetircList(evaluatefusionDBForm) {
            const queryParams = new URLSearchParams(evaluatefusionDBForm);

            try {
                const response = await this.$http.get(`/records/get_metrics_by_dm?${queryParams.toString()}`, {
                    headers: this.getAuthHeaders(),
                });
                console.log(response);
                this.evaluatedmetirclist = response.data.metric_ids;
                console.log(this.evaluatedmetirclist);
            } catch (error) {
                this.handleRequestError(error, "指标列表获取失败");
            }
        },

        async confirmSelection() {
            const metricIDsToSubmit = this.selectMetircList.filter(
                id => !this.evaluatedmetirclist.includes(id)
            );

            if (!metricIDsToSubmit.length) {
                this.$message.warning("All EvaNet metrics for this dataset have already been evaluated");
                this.dialogVisible = false;
                this.selectMetircList = [];
                return;
            }

            const payload = {
                MetricIDs: metricIDsToSubmit,
                DatasetID: this.evaluatefusionDBForm.DatasetID,
                MethodID: this.evaluatefusionDBForm.MethodID
            };

            try {
                await this.$http.post("/start_task", payload, {
                    headers: this.getAuthHeaders()
                });
                this.$message.success("Evaluation started. Please check the Status for progress");
            } catch (error) {
                this.handleRequestError(error, "Failed to start evaluation");
            }

            this.dialogVisible = false;
            this.selectMetircList = [];
        },
        handleClose() {
            this.selectMetircList = [];
        },




    },
};
</script>

<style lang="less" scoped>
.el-card__body {
    padding: 10px;
}

.error {
    color: rgb(226, 14, 14);
}

.code-block {
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    padding: 12px;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: Consolas, Monaco, monospace;
    font-size: 13px;
    line-height: 1.6;
    color: #303133;
}

</style>